import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { IStore } from '../../domain/store/IStore';
import Snackbar from '../component/base/Snackbar';
import HeaderBar from '../component/HeaderBar';
import ErrorScreen from '../component/ErrorScreen';
import DevTool from '../component/DevTool';
import LoadingScreen from '../component/LoadingScreen';
import OrganizationSetting from '../component/OrganizationSetting';
import { RoundMonitor } from '../component/RoundMonitor';
import Toolbar from '../component/Toolbar';
import { colors } from 'kaizen-ui-colors/lib';

interface IProps {
  store?: IStore;
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const AppHeader = styled.div`
  z-index: 2;
  position: relative;
`;

const AppBody = styled.div`
  flex-grow: 1;
  padding: 76px 12px 28px;
  background-color: ${colors.mochi_dark__ebedef};

  @media (min-width: 576px) {
    padding: 76px 24px 28px;
  }
`;

@inject('store')
@observer
class App extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { uiState } = this.store;

    return (
      <AppContainer>
        <AppHeader>
          <HeaderBar />
          <Toolbar />
        </AppHeader>
        <AppBody>
          <LoadingScreen />
          {uiState.isReady && uiState.hasError ? <ErrorScreen /> : null}
          {uiState.isReady && !uiState.hasError && uiState.mode == 1 ? <RoundMonitor /> : ''}
          {uiState.isReady && !uiState.hasError && uiState.mode == 2 ? <OrganizationSetting /> : ''}
        </AppBody>
        <Snackbar />
        <DevTool position={{ bottom: 0, left: 20 }} />
      </AppContainer>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/container/App.tsx